<p-tabView [activeIndex]="activeIndex" (onChange)="onTabChange($event)">
  <p-tabPanel *ngFor="let tab of filteredTabs" [header]="tab.name"></p-tabPanel>
</p-tabView>
